import api from "./api";
import {data} from "framer-motion/m";

const AuthAPI = {
    checkPassword: (password) => api.post(`/auth/check-password/${password}`),
    changePassword: (data) => api.post(`/auth/change-password`, data),
    verifyTempToken: (params) => api.post(`/auth/verify-temp-token`, params),
    emailConfirmCode: (params) => api.post(`/auth/email-confirm-code`, params),
    resendConfirmCode: (params) => api.post(`/auth/resend-confirm-code`, params),
    forgotPassword: (email) => api.post(`/auth/forgot-password`, { Email: email }),
    resetVerifyLink: (params) => api.post(`/auth/reset-password-verify-link`, params),
    resetPassword: (params) => api.post(`/auth/reset-password`, params),
    enable2Fa: () => api.get(`/auth/enable-2fa`),
    disable2Fa: (params) => api.post(`/auth/disable-2fa`, params),
    verify2FaCode: (url) => api.post(url),
    sign2Fa: (userId, mfaCode) => api.post(`/auth/signin-2fa/${userId}/${mfaCode}`),
    hasTwoFactor: () => api.get(`/auth/has-two-factor`),
    verifyAuthUser: () => api.get(`/auth/user/me`),
    getCurrentAccount: () => api.get(`/auth/current-account`),
    signOut: () => api.post(`/auth/sign-out`),
    deleteAccount: (data) => api.post(`/auth/delete-account`, data),
    recoverAccount: (data) => api.post(`/auth/recover-account`, data),
    
    // Passkey / WebAuthn endpoints
    requestPasskeyRegistration: () => api.post(`/auth/passkey/register/request`),
    verifyPasskeyRegistration: (data) => api.post(`/auth/passkey/register/verify`, data),
    requestPasskeyLogin: (data) => api.post(`/auth/passkey/login/request`, data),
    verifyPasskeyLogin: (data) => api.post(`/auth/passkey/login/verify`, data),
};

export default AuthAPI;